<template>
  <v-dialog v-model="active" persistent>
    <v-card class="pb-3">
      <v-card-title class="text-h5"> Tem certeza que deseja desativar a seção {{ section?.description }}? </v-card-title>
      <v-card-text>Esta ação só poderá ser desfeita através do suporte técnico.</v-card-text>
      <v-card-actions mb-2>
        <v-btn color="blue-grey darken-1" width="48%" depressed outlined dark :loading="loading" @click="closeModal"> Cancelar </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" width="48%" depressed outlined dark @click="saveModal" :loading="loading"> Desativar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  emits: ['close', 'save'],
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    section: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false
    };
  },
  watch: {
    isActive(newValue) {
      this.active = newValue;
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    saveModal() {
      this.$emit('save');
    }
  }
};
</script>
